module.exports = __webpack_public_path__ + "static/media/rocket.7461c5ac.svg";